import { module } from 'angular';

import { default as iframeOnloadDirectiveName, IframeOnloadDirective } from './iframe-onload.directive';

export default module('contact.commons.toolbox.iframe-onload', []).directive(iframeOnloadDirectiveName, IframeOnloadDirective).name;
